import {
  TablePage,
  AddPage,
  EditPage,
  ViewPage,
} from 'src/views/equipmentmaster'
import pathMap from 'src/paths/pathMap'

class EquipmentMasterRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.EQUIPMENT_MASTER_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.EQUIPMENT_MASTER_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.EQUIPMENT_MASTER_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.EQUIPMENT_MASTER_DETAILS_VIEW,
        component: ViewPage
      }
    ]
  }
}

export default EquipmentMasterRoute
